/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { ITEM } from 'garaje/utils/enums';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('billing-v1')
class SubscriptionEstimateModel extends Model {
  @belongsTo('invoice-estimate', { async: false }) currentInvoiceEstimate;
  @belongsTo('invoice-estimate', { async: false }) nextInvoiceEstimate;
  @belongsTo('subscription') subscription;
  @belongsTo('location-subscription') locationSubscription;

  @attr('string') app;
  @attr('string') couponCode;
  @attr('string') period;
  @attr('string') plan;
  @attr('date') nextBillingAt;
  @attr('number') quantity;

  @alias('nextInvoiceEstimate.discounts') discounts;
  @alias('nextInvoiceEstimate.taxes') taxes;
  @alias('nextInvoiceEstimate.total') total;
  @alias('nextInvoiceEstimate.lineItems') lineItems;

  @computed('app')
  get item() {
    switch (this.app) {
      case 'deliveries':
        return ITEM.DELIVERIES;
      case 'rooms':
        return ITEM.ROOMS;
      default:
        return ITEM.VISITORS;
    }
  }
}

export default SubscriptionEstimateModel;
